import { UtcDate } from '@/helpers/date';

export default {
  validate: (propertyPurchasedDate) => {
    const purchasedDate = new UtcDate(propertyPurchasedDate);

    return {
      required: true,
      valid: propertyPurchasedDate && purchasedDate.isValid(),
    };
  },
  message: (fieldName, { _value_: propertyPurchasedDate }) => {
    const purchasedDate = new UtcDate(propertyPurchasedDate);
    if (!propertyPurchasedDate || !purchasedDate.isValid()) return 'Please enter the month & year of purchase.';
  },
  computesRequired: true,
};
